// userUtils.js

export const filterUsers = (users, inputValue) => {
    return users && users.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
};